var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasMeter250DpEff5F2Fill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#EFF5F2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-120q-49.5 0-84.75-35.25T200-240v-400q0-49.5 35.25-84.75T320-760h64.62v-80h30.76v80h129.24v-80h30.76v80H640q49.5 0 84.75 35.25T760-640v400q0 49.5-35.25 84.75T640-120H320Zm0-30.77h320q37.56 0 63.39-25.84 25.84-25.83 25.84-63.39v-400q0-37.56-25.84-63.39-25.83-25.84-63.39-25.84H320q-37.56 0-63.39 25.84-25.84 25.83-25.84 63.39v400q0 37.56 25.84 63.39 25.83 25.84 63.39 25.84Zm20-438.46h280V-620H340v30.77Zm139.87 310.38q29.28 0 49.32-20.03 20.04-20.04 20.04-47.78 0-22.57-13.21-38.87-13.22-16.29-56.02-66.39-43.08 50.3-56.15 66.54-13.08 16.24-13.08 38.2 0 28.26 19.91 48.3 19.91 20.03 49.19 20.03Zm-249.1-450.38v578.46-578.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasMeter250DpEff5F2Fill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/gas_meter_250dp_EFF5F2_FILL0_wght200_GRAD0_opsz48.24202e3c84db7f05cbf9dc945ffec190.svg";
export { ForwardRef as ReactComponent };